<script setup>

</script>

<template>
    <svg width="32" height="31" viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.4288 1.64153C14.9234 0.119488 17.0766 0.11949 17.5712 1.64153L19.8729 8.72562C20.228 9.81832 21.2463 10.5581 22.3952 10.5581H29.8438C31.4442 10.5581 32.1096 12.606 30.8149 13.5467L24.7888 17.9249C23.8593 18.6002 23.4704 19.7973 23.8254 20.89L26.1271 27.9741C26.6217 29.4961 24.8796 30.7618 23.5849 29.8211L17.5588 25.4429C16.6293 24.7676 15.3707 24.7676 14.4412 25.4429L8.41508 29.8211C7.12036 30.7618 5.37831 29.4961 5.87285 27.9741L8.17461 20.89C8.52965 19.7973 8.14071 18.6002 7.2112 17.9249L1.18512 13.5467C-0.109606 12.606 0.555795 10.5581 2.15617 10.5581H9.60482C10.7537 10.5581 11.772 9.81832 12.1271 8.72562L14.4288 1.64153Z" />
    </svg>


</template>

<style scoped>

</style>
